import { createFileRoute, redirect } from "@tanstack/react-router";

import { CompanyStep } from "~/pages/onboard/steps/company-step";

/**
 * Personal onboarding step #3: create a workspace (org). After the user
 * submits, the step flips `user.onboarding` to `"done"` and `org.onboarding`
 * is advanced to `"plan"` by `setCompany` server-side.
 *
 * No `activeOrganization$` check here -- the step component briefly holds
 * `user.onboarding === "workspace"` AND has an active org during the
 * transition into the org-level flow. The resume guard handles the
 * already-completed case (user.onboarding === "done").
 */
export const Route = createFileRoute("/onboard/workspace")({
  beforeLoad: ({ context }) => {
    if (context.user?.onboarding !== "workspace") {
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: CompanyStep,
});
